import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@app/shared/utils/common';

const progressVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    indicatorColor: {
      accent: 'bg-accent',
      orange: 'bg-[linear-gradient(to_right,#FF7300,#FF9900)]',
      gradientBlue:
        'bg-[linear-gradient(270deg,rgba(11,135,249,0.5)_0%,rgba(11,135,249,0.1)_100%)] shadow-[inset_0_0_20px_0_hsla(0,0%,100%,0.9)]',
      gradientCyan: 'bg-[linear-gradient(to_right,#1065FF,#42FFC5,#FFFFFF)]',
    },
  },
  defaultVariants: {
    indicatorColor: 'accent',
  },
});

interface ProgressProps
  extends
    React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>,
    VariantProps<typeof progressVariants> {
  value?: number;
  max?: number;
}

const Progress = React.forwardRef<React.ComponentRef<typeof ProgressPrimitive.Root>, ProgressProps>(
  ({ className, value = 0, max = 100, indicatorColor, ...props }, ref) => {
    return (
      <ProgressPrimitive.Root
        ref={ref}
        value={value}
        max={max}
        className={cn(
          'relative h-2 w-full overflow-hidden rounded-full bg-secondary-foreground/20',
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={cn(progressVariants({ indicatorColor }))}
          style={{ transform: `translateX(-${String(100 - (value / max) * 100)}%)` }}
        />
      </ProgressPrimitive.Root>
    );
  }
);

Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
